import $ from 'jquery';
import 'bootstrap';
$('.collapse').collapse();